export function formatCurrency(value: number) {
  return value
    ? value.toLocaleString("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 20,
      })
    : "0";
}
